import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./staff.css";

const ROLES = [
  // 🎓 Academic
  "Principal","Vice Principal","Head Master","Head Mistress",
  "Class Teacher","Subject Teacher","Assistant Teacher",
  "PGT Teacher","TGT Teacher","PRT Teacher","Nursery Teacher",
  "Special Educator","Physical Education Teacher","Music Teacher",
  "Dance Teacher","Art Teacher","Computer Teacher","Lab Assistant","Librarian",
  // 🏢 Administrative
  "Accountant","Clerk","Office Staff","Receptionist",
  "Admission Counselor","Exam Coordinator",
  // 🚌 Transport
  "Transport Manager","Bus Driver","Bus Conductor",
  // 🏠 Hostel
  "Hostel Warden","Assistant Warden","Mess Manager","Cook","Kitchen Staff",
  // 🧹 Support
  "Peon","Cleaner","Security Guard","Maintenance Staff","Electrician","Plumber",
  // 🔧 Others
  "IT Support","System Administrator","Other",
];

export default function AddStaff() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [photo,      setPhoto]      = useState(null);
  const [preview,    setPreview]    = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const [form, setForm] = useState({
    name: "", phone: "", email: "",
    role: "", salary: "", joining_date: "",
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleFile = (file) => {
    if (!file) return;
    setPhoto(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return alert("Enter staff name");
    if (!form.role.trim()) return alert("Select a role");
    try {
      setSubmitting(true);
      const fd = new FormData();
      Object.keys(form).forEach(k => fd.append(k, form[k]));
      if (photo) fd.append("photo", photo);
      await API.post("/school-admin/staff/add/", fd, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      navigate("/school-admin/staff");
    } catch (err) { console.error(err); alert("Error adding staff"); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="st-page">

      {/* ══ HERO ══ */}
      <div className="st-hero">
        <div className="st-hero-left">
          <div className="st-hero-icon">➕</div>
          <div>
            <h2 className="st-hero-title">Add Staff Member</h2>
            <p className="st-hero-sub">Register a new non-teaching staff member</p>
          </div>
        </div>
        <div className="st-hero-right">
          <button className="st-btn-back" onClick={() => navigate("/school-admin/staff")}>
            ← Back
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit}>

        {/* ══ PHOTO UPLOAD ══ */}
        <div className="st-form-card">
          <p className="st-form-section-title">Staff Photo</p>
          <div
            className="st-photo-box"
            onDrop={e => { e.preventDefault(); handleFile(e.dataTransfer.files?.[0]); }}
            onDragOver={e => e.preventDefault()}
            onClick={() => !preview && document.getElementById("st-file-input").click()}
          >
            {preview ? (
              <img src={preview} alt="Preview" className="st-photo-preview" />
            ) : (
              <div className="st-photo-inner">
                <div style={{ fontSize: "36px", marginBottom: "10px" }}>📷</div>
                <p style={{ fontWeight: 700, color: "#4c1d95", margin: "0 0 4px" }}>Upload Staff Photo</p>
                <p style={{ fontSize: "12px", color: "#94a3b8", margin: 0 }}>Drag &amp; drop or click to browse</p>
              </div>
            )}
            <input
              id="st-file-input"
              type="file"
              hidden
              accept="image/*"
              onChange={e => handleFile(e.target.files[0])}
            />
          </div>
          {preview && (
            <button
              type="button"
              className="st-photo-browse"
              onClick={() => document.getElementById("st-file-input").click()}
            >
              Change Photo
            </button>
          )}
        </div>

        {/* ══ DETAILS ══ */}
        <div className="st-form-card">
          <p className="st-form-section-title">Personal &amp; Role Details</p>
          <div className="st-grid-2">
            <div className="st-field">
              <label>Full Name *</label>
              <input
                required
                placeholder="Enter staff full name"
                value={form.name}
                onChange={e => set("name", e.target.value)}
              />
            </div>
            <div className="st-field">
              <label>Role *</label>
              <select required value={form.role} onChange={e => set("role", e.target.value)}>
                <option value="">— Select Role —</option>
                {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
            <div className="st-field">
              <label>Phone</label>
              <input
                placeholder="Phone number"
                value={form.phone}
                onChange={e => set("phone", e.target.value)}
              />
            </div>
            <div className="st-field">
              <label>Email</label>
              <input
                type="email"
                placeholder="Email address (optional)"
                value={form.email}
                onChange={e => set("email", e.target.value)}
              />
            </div>
            <div className="st-field">
              <label>Monthly Salary (₹)</label>
              <input
                type="number"
                min="0"
                placeholder="e.g. 8000"
                value={form.salary}
                onChange={e => set("salary", e.target.value)}
              />
            </div>
            <div className="st-field">
              <label>Joining Date</label>
              <input
                type="date"
                value={form.joining_date}
                onChange={e => set("joining_date", e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* ══ SUBMIT ══ */}
        <div className="st-form-card">
          <button type="submit" className="st-btn-submit" disabled={submitting}>
            {submitting
              ? <><div className="st-spinner"></div> Saving…</>
              : "✓ Add Staff Member"
            }
          </button>
        </div>

      </form>
    </div>
  );
}
